module.exports = __webpack_public_path__ + "static/media/ResourcePlanning.73590394.svg";